import {
	ROOM_LOADING,
	ROOM_VALIDATION_SUCCESS,
	ROOM_ERROR,
	ROOM_LEAVE,
	ROOM_CLEAR_ERROR,
	ROOM_SENT_MESSAGE,
} from "../actions/actionTypes";

const initialState = {
	isLoading: false,
	_id: "",
	roomName: "",
	messages: [{}],
	err: "",
};

function roomReducer(state = initialState, action) {
	switch (action.type) {
		case ROOM_LOADING:
			return { ...state, isLoading: true };
		case ROOM_VALIDATION_SUCCESS:
			return {
				...state,
				_id: action.payload._id,
				roomName: action.payload.roomName,
				messages: action.payload.messages,
				isLoading: false,
			};
		case ROOM_SENT_MESSAGE:
			return {
				...state,
				messages: [
					...state.messages,
					{
						_id: action.payload._id,
						username: action.payload.username,
						message: action.payload.message,
						date: action.payload.date,
					},
				],
			};
		case ROOM_ERROR:
			return { ...state, err: action.payload.error };
		case ROOM_LEAVE:
			return {
				isLoading: false,
				_id: "",
				roomName: "",
				messages: [{}],
				err: "",
			};
		case ROOM_CLEAR_ERROR:
			return { ...state, err: "" };
		default:
			return state;
	}
}

export default roomReducer;
